import { ButtonView, Plugin } from 'ckeditor5'
import { PasteAsTextCommand } from './PasteAsTextCommand'

export class PasteAsTextPlugin extends Plugin {
  static get pluginName() {
    return 'PasteAsText'
  }

  init() {
    const editor = this.editor

    // Add the paste as text command
    editor.commands.add('pasteAsText', new PasteAsTextCommand(editor))

    // Add the paste as text button to the toolbar
    editor.ui.componentFactory.add('pasteAsText', (locale) => {
      const command = editor.commands.get('pasteAsText')
      const buttonView = new ButtonView(locale)

      buttonView.set({
        label:
          global.window.CKEDITOR_TRANSLATIONS[locale.contentLanguage]
            ?.dictionary?.PasteAsText,
        icon: '<svg></svg>',
        tooltip: true,
      })

      if (command) {
        buttonView.bind('isEnabled').to(command, 'isEnabled')
      }

      buttonView.on('execute', () => {
        editor.execute('pasteAsText')
      })

      return buttonView
    })
  }
}
